import { useState, useCallback } from 'react';

export const usePinnedModel = (onPinnedModelChange) => {
  const [pinnedModel, setPinnedModel] = useState(() => {
    return localStorage.getItem('pinned-model') || null;
  });

  const handlePinModel = useCallback((model) => {
    const modelString = model.value;
    setPinnedModel(modelString);
    localStorage.setItem('pinned-model', modelString);
    if (onPinnedModelChange) {
      onPinnedModelChange(modelString);
    }
  }, [onPinnedModelChange]);

  const handleUnpinModel = useCallback(() => {
    setPinnedModel(null);
    localStorage.removeItem('pinned-model');
    if (onPinnedModelChange) {
      onPinnedModelChange(null);
    }
  }, [onPinnedModelChange]);

  return {
    pinnedModel,
    handlePinModel,
    handleUnpinModel
  };
};
